export enum TradeStrategy {
  MARKET = "MARKET",
  LIMIT = "LIMIT",
  FOLLOW = "FOLLOW",
  FLEX = "FLEX"
}

export enum TradeSide {
  ASK = "ASK", // 卖出
  BID = "BID" // 买入
}

export * from "./atm";
export * from "./order";
export * from "./c2c";
export * from "./wyre";
